export const DOCTOR_STATUS_MAPPED = new Map([
  [0, 'Inactive'],
  [1, 'Active'],
  [2, 'Deactivated']
])
